import gql from 'graphql-tag'

export const fetchUpdateCartItemsMutation = gql(`
mutation ($cart_id: String!, $cart_items: [CartItemUpdateInput]!) {
  updateCartItems(
    input: {
      cart_id: $cart_id
      cart_items: $cart_items
    }
  ) {
      cart {
        note_for_driver
        customer_order_number
        delivery_date
        delivery_method
        sap_payment_details
        outlet_details {
          outlet_name
        }
        payer_details {
          street
          city
          zipcode
        }
        progress_bar_data {
          iPalletQuantity,
          iMinimumOrderWeight,
          iMaximumOrderWeight,
          iTotalCartWeight,      
          iTotalCartPalletQty,
          iTotalQty,      
          iRunnerType,
          iFullTruck,
          iFullTruckFlag,
          iFullTruckRemaining,      
          msg,
          canProceed,
          min_weight_reached,
          iTruckQuantity
        }
        available_payment_methods {
          code
          title
        }
        selected_payment_method {
          code
          title
        }
        id
        email
        multi_deposit
        ship_to_id
        cart_prices {
          grand_total_deposit
          grand_total_price
          grand_total_price_with_vat
          grand_total_price_with_vat_returnable
          returnable_items{
            parent_sku
            sku
            total_units
            total_price
            unit_price
            name
          }
        }
        items {
          id
          product {
            name
            sku
            runner_type
            product_relation
            url_key
            material_type
            number_of_items_in_box
            swatch_image
            number_of_products_on_layer
            number_of_layers_per_pallet
            number_of_items_on_pallet
            image {
              url
            }
            ... on BundleProduct {
              bundle_price_sum
              bundle_price_sum_tax
              your_price_sum
              your_price_sum_tax
            }
            __typename
          }
          ... on BundleCartItem {
              bundle_options {
                uid
                label
                type
                values {
                  id
                  label
                  price
                  quantity
                }
              }
            }
          quantity
          quantity_total
          number_of_packages
          number_of_layer
          number_of_layer_total
          number_of_pallet
          number_of_trucks
          pack_format
        }
      }
    }
  }
`)
